import React from 'react';
import ResumeBuilder from '../../ResumeBuilder';

export default function ResumeBuilderSection() {
  return <ResumeBuilder />;
}
